export function formatRating(rating: number): string {
  const clamped = Math.min(5, Math.max(0, rating));
  const formatted = clamped.toFixed(1);
  return formatted.endsWith('.0') ? formatted.slice(0, -2) : formatted;
}
